/**
 * modules/lazy-contact.js
 * Chargement à la demande du script du formulaire de contact
 */

import { loadTurnstileScript } from './turnstile.js';

/**
 * Initialise le chargement différé du formulaire de contact
 */
export function initLazyContactForm() {
    // Sélectionner tous les éléments qui ouvrent le modal de contact
    const contactButtons = document.querySelectorAll('[data-bs-target="#contactModal"]');
    
    if (contactButtons.length > 0) {
      // Ajouter un gestionnaire d'événement pour charger le script uniquement au clic
      contactButtons.forEach(button => {
        button.addEventListener('click', function() {
          // Précharger le script Turnstile
          loadTurnstileScript();
          
          // Charger le script du formulaire de contact
          loadContactFormScript();
        }, { once: true });
      });
    }
  }
  
  /**
   * Fonction pour charger le script de formulaire de contact
   */
  function loadContactFormScript() {
    // Vérifier si le script est déjà chargé
    if (window.contactScriptLoaded) return;
    
    // Création d'un script de type module
    const script = document.createElement('script');
    script.src = '/js/modules/contact-form.js'; // Chemin vers le script de contact
    script.type = 'module'; // Utiliser le type module pour permettre l'import de modules ES6
    script.async = true;
    
    script.onload = function() {
      console.log('Script de formulaire de contact chargé avec succès');
      window.contactScriptLoaded = true;
    };
    
    script.onerror = function() {
      console.error('Erreur lors du chargement du script de formulaire de contact');
    };
    
    document.body.appendChild(script);
  }
  
  /**
   * Utilitaire pour afficher des toasts (peut être utilisé par d'autres modules)
   * @param {string} message - Le message à afficher dans le toast
   * @param {string} type - Le type de toast (success, danger, warning, info)
   */
  export function showToast(message, type = 'info') {
    const iconMap = {
      success: 'fa-check-circle',
      danger: 'fa-exclamation-circle',
      warning: 'fa-exclamation-triangle',
      info: 'fa-info-circle'
    };
    
    const icon = iconMap[type] || iconMap.info;
    const toastId = 'toast-' + Math.random().toString(36).substring(2, 9);
    
    const toastHTML = `
      <div class="position-fixed bottom-0 end-0 p-3" style="z-index: 9999">
        <div id="${toastId}" class="toast align-items-center text-white bg-${type} border-0" role="alert" aria-live="assertive" aria-atomic="true">
          <div class="d-flex">
            <div class="toast-body">
              <i class="fas ${icon} me-2"></i> ${message}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
          </div>
        </div>
      </div>
    `;
    
    document.body.insertAdjacentHTML('beforeend', toastHTML);
    
    // Créer l'instance de toast avec Bootstrap
    if (window.bootstrap && window.bootstrap.Toast) {
      const toast = new bootstrap.Toast(document.getElementById(toastId), {
        delay: 5000
      });
      toast.show();
      
      // Nettoyage automatique du DOM après que le toast disparaît
      document.getElementById(toastId).addEventListener('hidden.bs.toast', function() {
        this.parentNode.remove();
      });
    } else {
      // Fallback si bootstrap n'est pas disponible
      console.log(`Toast (${type}): ${message}`);
    }
  }